import Model from "@/components/common/model.component";
import FertigatorsFrom from "./FertigatorsFrom";
import PageTitle from "components/common/page-title.component";

export default function AddFertigators(props) {
  const {
    showModalFertigators,
    setShowModalFertigators,
    suppliersData,
    label,
  } = props;

  return (
    <Model
      width="w-[65rem]"
      show={showModalFertigators}
      onClose={(e) => {
        setShowModalFertigators(false);
      }}
    >
      <PageTitle title={label} titletextSize="text-xl" />

      <FertigatorsFrom
        setShowModalFertigators={setShowModalFertigators}
        defaultValues={{}}
        icon="FRG-"
        rowData={{}}
      />
    </Model>
  );
}
